var showing = false;

export default function project_overlay(){

    

    var projectOverlay = document.querySelector('.project-overlay');
    var mainOVer =  1;

    if(!projectOverlay){
        projectOverlay = document.querySelector('.project-case-study');
        mainOVer =  0;
    }

    var scroller = document.querySelector('.scroller');


    
   
    if(projectOverlay){
        showing = true;

        if(scroller){
            scroller.style.position = 'fixed';
        }

        const prompts = document.querySelectorAll('.prompt');
        for (let a = 0; a < prompts.length; a++) {
   
            const prompt = prompts[a];

            if(!prompt.classList.contains('typed')){
                prompt.classList.add('typed');
                // const string = prompt.innerHTML;
                // if(string){
                //     prompt.innerHTML = '';
                //     typeOut(prompt, string, 10, (a+10)*100);
                // }
            }
            
        }


        let isDown = false;
        let startX;
        let scrollLeft;

        projectOverlay.addEventListener('mousedown', (e) => {

            const hasClassInPath = e.composedPath().some(element => {
                return element.classList && element.classList.contains('c-wrap');
            }); 

            if(!hasClassInPath){
                isDown = true;
            
                startX = e.pageX - projectOverlay.offsetLeft;
                scrollLeft = projectOverlay.scrollLeft;
                projectOverlay.style.cursor = 'grabbing'; 
            }
        });

        projectOverlay.addEventListener('mouseleave', () => {
            isDown = false;
            projectOverlay.style.cursor = 'unset'; 
            projectOverlay.classList.remove('dragging');
        });

        projectOverlay.addEventListener('mouseup', () => {
            isDown = false;
            projectOverlay.style.cursor = 'unset'; 
            projectOverlay.classList.remove('dragging');
        });

        projectOverlay.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            projectOverlay.classList.add('dragging');
            const x = e.pageX - projectOverlay.offsetLeft;
            const walk = (x - startX) * 2; 

            projectOverlay.scrollTo({
                left: scrollLeft - walk,
                behavior: 'instant'
            });
            
        });


        projectOverlay.addEventListener('click', function(e){
            
            const hasClassInPath = e.composedPath().some(element => {
                return element.classList && element.classList.contains('assets') ;
            }); 
            
            
            if(projectOverlay.classList.contains('dragging')){
                e.preventDefault();
            }else{

                if (!hasClassInPath) {
                    hide_elm(projectOverlay);
                } else {
                   e.preventDefault();
                }
            }
    
            
        });

        projectOverlay.classList.add('vis');
       

        function pro_scroll(e) {
    
            if(!window.fullscreen){

                var scrollX = projectOverlay.scrollTop;
                var scrollableWidth = projectOverlay.scrollHeight - projectOverlay.clientHeight;
                var scrollLeftToEnd = scrollableWidth - scrollX;

                if(window.innerWidth > 659 ){

                     scrollX = projectOverlay.scrollLeft;
                     scrollableWidth = projectOverlay.scrollWidth - projectOverlay.clientWidth;
                     scrollLeftToEnd = scrollableWidth - scrollX;

                }

                if(scrollLeftToEnd < 30){

                    hide_elm(projectOverlay);
                    
                }else{
                    
                    // console.log('his:', window.his);
                    // console.log('path:', window.location.pathname);

                    if(scrollLeftToEnd < 300){
                        const op = (scrollLeftToEnd - 200) / 100;
                        projectOverlay.style.backdropFilter = `blur(${(op*10)-5}px)`;
                        projectOverlay.style.opacity = op;
                    }else{
                        projectOverlay.style.opacity = 1;
                        projectOverlay.style.backdropFilter = "blur(5px)";
                    }
                }

                

            }

        };

        function vert_scroll(e){

            if(!window.fullscreen){
                const scrollY = projectOverlay.scrollTop;

                
                const scrollableHeight = projectOverlay.scrollHeight - projectOverlay.clientHeight;
                const scrollLeftToEnd = scrollableHeight - scrollY;


                if(scrollLeftToEnd < 100){
                    hide_elm(projectOverlay);
                }else{
                    if(scrollLeftToEnd < 200){
                        const op = (scrollLeftToEnd - 200) / 100;
                        projectOverlay.style.opacity = op;
                    }else{
                        projectOverlay.style.opacity = 1;
                    }
                }
            }
        };


        var lazy = projectOverlay.querySelectorAll('.lazy');

        const lazyLoad = (entries, observer) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                    load_asset(entry.target, 0);
                  observer.unobserve(entry.target);
              }
            });
        };
        
      
        const observer = new IntersectionObserver(lazyLoad, {
            rootMargin: '1000px',
            threshold: 0
        });
        
      
        lazy.forEach(assetBox => {
            observer.observe(assetBox);
        });

        
        if(mainOVer){
            projectOverlay.addEventListener('scroll', pro_scroll);
        }else{
            projectOverlay.addEventListener('scroll', vert_scroll);
        }

    }


    
    function load_asset(asset, i){

        let url =  asset.dataset.src;
        let project = asset.closest('.project-asset');

        const img = new Image();
        asset.onload = function() {

            asset.classList.remove('lazy');
            project.classList.add('loaded');
            
        }

        asset.src = url;
        
    };

    function isImageURL(url) {
        return (url.match(/\.(jpeg|jpg|gif|png|svg|webp|bmp|tiff)$/i) != null);
    }

}

function typeOut(element, text, speed, delay) {

    let index = 0;
    
    const words = text.split(' ');

    function type() {

        if (index < words.length-1) {
            element.textContent += words[index] + ' ';
            index++;
            index++;
    
            setTimeout(type, speed);
  
        }else{
            element.textContent = text;
        }
    
    }
  
    setTimeout(function(){
      type();
    }, delay);
  }

  function hide_elm(projectOverlay, fade){

        if(showing){
        showing = false;
        let delay = 1000;

        if(!fade){
            delay = 0;
        }

    
        setTimeout(function(){

            var projectOverlay = document.querySelector('.project-overlay');

            if(!projectOverlay){
                projectOverlay = document.querySelector('.project-case-study');
            }

            if(projectOverlay){
                projectOverlay.parentNode.removeChild(projectOverlay);
            }


            if(window.his && window.his !== window.location.pathname){

                window.history.pushState({}, '', window.his);  

            }else{

                window.history.pushState({}, '', '/');  

                if(!document.querySelector('.fixed-grid')){
                    document.querySelector('.home-link').click();
                }
                
            }

        }, delay);

    }else{
        return false;
    }

  }